window.casino = window.casino || {};
var repos = window.casino.repos = window.casino.repos || {};

repos.prekidSamoiskljucenjaRepo = function () {
    var url = 'api/prekidsamoiskljucenja';

    var create = function (eventId) {
        return fetch(url, {
            method: 'POST',
            credentials: repos.base.credentials,
            headers: repos.base.headers(),
        }).catch(casino.repos.base.handleNetworkException);
    };


    return {
        create: create
    }

}();